<div class="sg" role="listbox" aria-label="Search suggestions">
  <ng-container *ngFor="let group of groups; trackBy: trackByLabel">
    <div class="sg-head">{{ group.label }}</div>
    <button type="button" role="option" class="sg-row" *ngFor="let item of group.items; trackBy: trackByPath"
      [class.is-active]="items[active] === item" [attr.aria-selected]="items[active] === item"
      (mousedown)="$event.preventDefault()" (click)="pick.emit(item)">
      <span class="sg-pic" [class.is-merch]="item.kind === 'merch'" [style.background-image]="item.pic ? 'url(' + item.pic + ')' : null"></span>
      <span class="sg-title notranslate">{{ item.title }}</span>
    </button>
  </ng-container>
  <div class="sg-note" *ngIf="!groups?.length">{{ loading ? 'Searching…' : failed ? 'Search is temporarily unavailable' : 'No matches — press Enter to search everything' }}</div>
</div>
